import { defineMeta } from '@/registry/types';

export const attackPathLegendMeta = defineMeta({
  name: 'AttackPathLegend',
  level: 'organism',
  category: 'data-display',
  classification: 'custom',
  description: 'Legend mapping attack-path node types to their stroke/fill colors, from design tokens.',
  baseLibrary: 'custom',
  a2uiEquivalent: 'Legend',
  importPath: '@/organisms/AttackPathLegend',
  optionalProps: ['types', 'orientation'],
  supportedStates: ['horizontal', 'vertical'],
  designTokens: ['attackPath', 'typography'],
  accessibility: ['Rendered as a labelled list; swatches are aria-hidden with text labels.'],
  usageExamples: ['<AttackPathLegend />', '<AttackPathLegend types={["host","role"]} />'],
  antiPatterns: ['Do not hardcode attack-path colors; always source from tokens.'],
  llmSafe: true,
  whenToUse: ['Alongside attack-path graphs/diagrams', 'Investigation layouts'],
  whenNotToUse: ['Generic status legends (use Chips)'],
  figma: 'https://www.figma.com/design/LJdrBxmaROpXg0hLW3GKe6/AiStrike-Complete-Design-System?node-id=23-476',
});

export default attackPathLegendMeta;
